'use es6';

import { forwardRef, memo } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import MenuItemLabel from 'simple-menus-lib/components/menu/MenuItemLabel';
import MenuItemOptions from 'simple-menus-lib/components/menu/MenuItemOptions';
import menuDropTarget from 'simple-menus-lib/components/dnd/decorators/menuDropTarget';
import withVisibilityChecker from 'simple-menus-lib/components/menu/decorators/withVisibilityChecker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuItem = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    menuId,
    parentId,
    canDrop,
    isOver,
    isCollapsed,
    isVisible,
    hasChildren,
    readOnly,
    toggleCollapse,
    connectDropTarget
  } = props;
  let itemBorderColor = 'border-core-default';
  if (isOver && !canDrop) {
    itemBorderColor = 'border-alert-default';
  } else if (isOver) {
    itemBorderColor = 'border-info-default';
  }
  const menuLeftContentDisplay = isVisible ? 'flex' : 'none';
  const menuRightContentDisplay = isVisible ? 'block' : 'none';
  return connectDropTarget( /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(View, {
      ref: ref,
      backgroundColor: "fill-surface-default",
      borderColor: itemBorderColor,
      borderStyle: "solid",
      borderWidth: "100",
      borderRadius: "100",
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(ScrollContainer, {
        children: /*#__PURE__*/_jsx(DragHandle, {
          position: "start",
          children: /*#__PURE__*/_jsxs(Flex, {
            "data-test-id": "menu-item",
            blockSize: "55px",
            paddingBlock: "200",
            paddingInlineStart: "600",
            paddingInlineEnd: "200",
            children: [/*#__PURE__*/_jsx(Box, {
              flex: "1 1 auto",
              paddingInlineEnd: "200",
              display: menuLeftContentDisplay,
              alignItems: "center",
              children: /*#__PURE__*/_jsx(MenuItemLabel, {
                id: id,
                hasChildren: hasChildren,
                toggleCollapse: toggleCollapse,
                isCollapsed: isCollapsed,
                readOnly: readOnly
              })
            }), /*#__PURE__*/_jsx(Box, {
              inlineSize: "calc(50% + 68px)",
              paddingInline: "200",
              display: menuRightContentDisplay,
              children: /*#__PURE__*/_jsx(MenuItemOptions, {
                id: id,
                isVisible: isVisible,
                parentId: parentId,
                menuId: menuId,
                readOnly: readOnly
              })
            })]
          })
        })
      })
    })
  }));
}), (prevProps, nextProps) => {
  return !nextProps.isVisible || prevProps.id === nextProps.id && prevProps.menuId === nextProps.menuId && prevProps.parentId === nextProps.parentId && prevProps.canDrop === nextProps.canDrop && prevProps.isOver === nextProps.isOver && prevProps.isCollapsed === nextProps.isCollapsed && prevProps.isVisible === nextProps.isVisible && prevProps.hasChildren === nextProps.hasChildren && prevProps.readOnly === nextProps.readOnly;
});
MenuItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  canDrop: PropTypes.bool,
  isOver: PropTypes.bool,
  isCollapsed: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  hasChildren: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  toggleCollapse: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired
};
export default compose(menuDropTarget(), withVisibilityChecker())(MenuItem);